class CardsController

  @showLostCardCode: (url) ->
    $.ajax({
      url: url,
      type: 'GET',
      data: {},
      dataType: 'json',
      success: (data, textStatus, jqXHR) ->
        if data['error']
          alert(data['error'])
        else
          $('#lost-card-code').text(data['lost_card_code'])
      error: (jqXHR, textStatus, errorThrown) ->
        console.error(textStatus, errorThrown)
    })

  @addValueSubmitButton: (paymentMethod, event) ->
    if paymentMethod == ""
      return;
    $("#add_value_submit_button").prop('disabled', $("input[name=amount]:checked").length == 0);


$(document).ready ->
  $(document).on('click', '#lost-card-code a', (event) ->
    CardsController.showLostCardCode($(this).data('url'))
  )

  $(document).on('click', 'input[type=radio][name=amount]', (event) ->
    CardsController.addValueSubmitButton($(this).data('payment_method'))
  )

module.exports = CardsController
